export const dashboardService = {
  apiDashboardData(urldata = mixins.params()) {
    return this.request(this.api().getDashboard)
      .urltransform(urldata)
      .exec()
      .log()
      .get();
  },
  apiEventDashboardData(data, urldata) {
    return this.request(this.api().getEventDashboard, data)
      .urltransform(urldata)
      .exec()
      .log()
      .mapresults((response) => {
        return {
          data: response.data[0].records,
          total: response.data[0].pagination[0]?.totalRecords || 0,
        };
      })
      .get();
  },
  apiGetEventReportPdf(urldata = {}) {

    return this.request(this.api().getEventReportPdf, urldata)
      .urltransform(urldata)
      .responsetype("blob")
      .exec()
      .log()
      .get();
  },

  apiGetEventReportExcel(urldata = {}) {

    return this.request(this.api().getEventReportExcel, urldata)
      .urltransform(urldata)
      .responsetype("blob")
      .exec()
      .log()
      .get();
  },
  apiGetDashboardBarChartData(urldata = mixins.params()) {
    return this.request(this.api().getDashboardBarChartData)
      .urltransform(urldata)
      .exec()
      .log()
      .get();
  },

  apiGetSessionProgressBarChart(urldata = mixins.params()) {
    return this.request(this.api().getSessionProgressBarChart)
      .urltransform(urldata)
      .exec()
      .log()
      .get();
  },
  apiGetMonthlyEventProgress(urldata = {}) {
    return this.request(this.api().getMonthlyEventProgress)
      .urltransform(urldata)
      .exec()
      .log()
      .get();
  },
};

export default dashboardService;